/**
 * Welke Admin-tabs iemand zonder admin_settings ziet: Feedback en het ikwilwerken@-deel van Algemene mailboxen
 * (recht werving). De server controleert elk endpoint opnieuw.
 *
 * `feedbackToegang`: optioneel. Develop leidt het af uit de rechten feedback_beheer/backlog; main geeft de
 * uitkomst van canAccessBacklogFeedback(email) mee (allowlist). Zo is dit bestand op beide branches gelijk.
 */
export function beperkteTabs(tabs, permissions, feedbackToegang) {
  if (permissions?.admin_settings?.view) return tabs;
  const feedback = feedbackToegang !== undefined
    ? !!feedbackToegang
    : !!(permissions?.feedback_beheer?.view || permissions?.backlog?.view);
  return tabs.flatMap((t) => {
    if (t.key === 'feedback' && feedback) return [t];
    if (t.key === 'mailboxen' && permissions?.werving?.view) {
      return [{ ...t, sections: (t.sections || []).filter((s) => s.key === 'ikwilwerken') }];
    }
    return [];
  });
}
